import { Grid } from '@mui/material';

import { FormAutocompleteField, FormNumberField, FormTextField } from '../../../../../../common';
import { US_STATE_OPTIONS } from '../../../../../../../constants';
import { ASD_SEVERITY_OPTIONS, MEDICAL_NUMERIC_FIELD_BOUNDS } from '../constants';

import type { MedicalFieldsProps } from './types';

export default function AsdDiagnosisFields({
  formik,
  disabled,
  saveFieldOnBlur,
}: MedicalFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="ASD severity level"
          name="f84_severity_level"
          onChange={saveFieldOnBlur}
          options={ASD_SEVERITY_OPTIONS}
          placeholder="Select severity level"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Provider name"
          name="f84_diagnosis_provider_name"
          onBlur={saveFieldOnBlur}
          placeholder="Enter provider name"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="City"
          name="f84_diagnosis_city"
          onBlur={saveFieldOnBlur}
          placeholder="Enter city"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3} md={1.5}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="State"
          name="f84_diagnosis_state"
          onChange={saveFieldOnBlur}
          options={US_STATE_OPTIONS}
          placeholder="State"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3} md={1.5}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Year"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.f84_diagnosis_year.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.f84_diagnosis_year.min}
          name="f84_diagnosis_year"
          onBlur={saveFieldOnBlur}
          placeholder="Select year"
          required
        />
      </Grid>
    </Grid>
  );
}
